import {createAsyncThunk} from '@reduxjs/toolkit'
import {getHttpRequestId} from 'modules/common/selectors'
import logBoFHService, {
  BoFHServiceEndpointNames,
  BoFHServiceStatus
} from 'performance/logBoFHService'
import {getCurrentBookingRequestId} from 'utils/bookingRequestId'

import {paymentSettingsApi} from '@vio/core/src/offer/services/paymentSettingsApi'

import {
  getPaymentSessionsActionLink,
  getPaymentSettingsParams
} from '../selectors'

import type {PaymentSession} from '@vio/core/src/offer/types/paymentSettings'
import type {RootState} from 'store'

/**
 * Resolves to `undefined` when the session can't be created. Request failures
 * are logged by the `createPaymentSession` rejection listener.
 */
export const createPayrailsSession = createAsyncThunk<
  PaymentSession | undefined,
  void,
  {state: RootState}
>(
  'paymentSettings/createPayrailsSession',
  async (_arg, {dispatch, getState}) => {
    const state = getState()
    const link = getPaymentSessionsActionLink(state)
    // BoVio ships the link separately from the payment method `integration`,
    // so it can be missing while payment-methods-settings already selects
    // Payrails.
    if (!link) {
      logBoFHService(
        BoFHServiceEndpointNames.PaymentSession,
        BoFHServiceStatus.error,
        {
          error: 'Missing payment_sessions link',
          request_id: getHttpRequestId(state),
          booking_request_id: getCurrentBookingRequestId()
        },
        'error'
      )
      return undefined
    }

    const {profileKey, clientUserAgent, httpRequestId} =
      getPaymentSettingsParams(state)
    const result = await dispatch(
      // Untracked, so the session credential never lands in the store.
      paymentSettingsApi.endpoints.createPaymentSession.initiate(
        {link, profileKey, clientUserAgent, httpRequestId},
        {track: false}
      )
    )
    return 'data' in result ? result.data : undefined
  }
)
